import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "atl",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const multiLevelNodeEditorReducer = importedModule1.default;
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer: multiLevelNodeEditorReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
